export const isFixedElementInSection = ($fixed_el: Element, $section_el: Element) => {
  const fixed_rect = $fixed_el.getBoundingClientRect();
  const section_rect = $section_el.getBoundingClientRect();

  return fixed_rect.bottom >= section_rect.top && fixed_rect.bottom <= section_rect.bottom;
};
